import {
  ServiceProviderQuery,
  useV2Gateway_QueryServiceProvidersLazyQuery,
  V2Gateway_QueryServiceProvidersQueryHookResult,
} from 'Generated/graphql';
import { useEffect, useMemo } from 'react';

export type UseServiceProviders = NonNullable<
  V2Gateway_QueryServiceProvidersQueryHookResult['data']
>['queryServiceProviders']['serviceProviders']

const useServiceProviders = (
  query?: ServiceProviderQuery,
): [UseServiceProviders | undefined, () => void, boolean] => {
  const [searchServiceProviders, searchServiceProvidersQuery] =
    useV2Gateway_QueryServiceProvidersLazyQuery();

  useEffect(() => {
    if (query) {
      searchServiceProviders({
        variables: {
          query,
        },
      });
    }
  }, [JSON.stringify(query)]);

  const serviceProviders = useMemo(() => {
    const { data } = searchServiceProvidersQuery;
    if (data?.queryServiceProviders) {
      return [...data.queryServiceProviders.serviceProviders];
    }
  }, [searchServiceProvidersQuery.data]);

  return [
    serviceProviders,
    () => searchServiceProvidersQuery.refetch &&
      searchServiceProvidersQuery.refetch(),
    searchServiceProvidersQuery.loading,
  ];
};

export default useServiceProviders;

